import React from "react";
import CssClasses from "./RightSectionTerminalActions.css";
import TerminalActions from "../../Components/Navigation/TerminalActions/TerminalActions";

const RightSectionTerminalActions = props => {
  return (
    <div className={CssClasses.container}>
      <TerminalActions />
    </div>
  );
};

export default RightSectionTerminalActions;



// WEBPACK FOOTER //
// ./src/Containers/RightSectionTerminalActions/RightSectionTerminalActions.js